import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import TablePagination from "../../common/components/TablePagination";
import commonEnLabels from '../../common/labels/common_en.json';
import { isAuthorized } from '../../helpers/AuthUtils';
import { getAllDebarUsers } from "../debarManagement/actions/debarManagementActions";
import AddDebarUser from "../debarManagement/components/addDebarUser";
import UpdateDebarUser from "../debarManagement/components/updateDebarUser";
import labels from '../debarManagement/labels/debar_users_en.json';
import { formatToDDMMYYYY } from "../../helpers/Datetime";

const DebarManagement = () => {
    const { allDebarUsersList } = useSelector(state => state.debarManagementReducer)
    const [addDebarModal, setAddDebarModal] = useState(false)
    const [updateDebarModal, setUpdateDebarModal] = useState(false)
    const [currentRowData, setCurrentRowData] = useState({})
    const dispatch = useDispatch()

    const { authData } = useSelector(state => state.loginReducer, shallowEqual);
    let deptRoles = authData && authData.deptRoles && authData.deptRoles[0] && authData.deptRoles[0].roleId;
    const hasCreateDebarPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "DEBAR_MGMT", "C");
    const hasUpdateDebarPermission = (deptRoles === commonEnLabels.DATABASE_VALUES.SUPER_ADMIN_ROLE_ID) ? true :  isAuthorized(authData, null, "DEBAR_MGMT", "U");

    useEffect(() => {
        dispatch(getAllDebarUsers(0, 10))
    }, [])

    return (
        <div className="table-responsive-lg px-4 py-2">
            {hasCreateDebarPermission &&
            <div className="p-2 d-flex justify-content-end">
                <button type="button" className=" btn btn-primary custom_button " onClick={() => { setAddDebarModal(true) }}>
                    Add New User
                </button>
            </div>}
            <table className="table rounded-table">
                <thead className="table-primary">
                    <tr >
                        {labels.headers.map((ele, index) =>
                            <th key={index} >{ele}</th>
                        )}
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px" }}>
                    {
                        allDebarUsersList.debarments && allDebarUsersList.debarments.map((debarData, index) => {
                            const {
                                candidateName,
                                fatherHusbandName,
                                motherName,
                                aadhaarNo,
                                mobileNo,
                                emailId,
                                dob,
                                pscName,
                                letterNo,
                                debarOn,
                                reason,
                                isPermanent,
                                dateFrom,
                                dateTo,
                            } = debarData
                            return (
                                <tr key={index}>
                                    <td>{candidateName}</td>
                                    <td>{fatherHusbandName}</td>
                                    <td>{motherName}</td>
                                    <td>{aadhaarNo}</td>
                                    <td>{mobileNo}</td>
                                    <td>{emailId}</td>
                                    <td>{formatToDDMMYYYY((dob))}</td>
                                    <td>{pscName}</td>
                                    <td>{letterNo}</td>
                                    <td>{debarOn}</td>
                                    <td>{reason}</td>
                                    <td>{isPermanent ? "Yes" : "No"}</td>
                                    <td>{formatToDDMMYYYY(dateFrom)}</td>
                                    <td>{formatToDDMMYYYY(dateTo)}</td>
                                    {hasUpdateDebarPermission &&
                                        <td className="d-flex align-items-center gap-2">
                                            <i
                                                data-toggle="tooltip"
                                                title="Update User"
                                                style={{ fontSize: "15px", color: "#007bff", cursor: 'pointer' }}
                                                className='fa fa-edit'
                                                aria-hidden="true"
                                                onClick={() => { setUpdateDebarModal(true); setCurrentRowData(debarData) }}
                                            />
                                            {/* <i data-toggle="tooltip" title="Delete User" style={{ fontSize: "15px", color: "red", cursor: 'pointer' }} className='fa fa-trash' aria-hidden="true" onClick={() => { }}></i> */}
                                        </td>
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            {
                allDebarUsersList.debarments &&
                <TablePagination
                    paginationFor="debar_users_list"
                    rowPerPage={10}
                    totalCount={allDebarUsersList.totalRecords}
                />
            }
            <AddDebarUser
                setAddDebarModal={setAddDebarModal}
                addDebarModal={addDebarModal}
            />
            <UpdateDebarUser
                setUpdateDebarModal={setUpdateDebarModal}
                updateDebarModal={updateDebarModal}
                currentRowData={currentRowData}
            />
        </div >
    )
}

export default DebarManagement;